import { FailedInfraResponse, MockInfraResponse } from "~/api/_common/InfraResponse"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { POST } from "~/api/_common/http"

export type PostAuthRegisterBody = {
  email: string
  password: string
  name: string
  sex?: string
  user_school: string
  user_faculty: string
  faculty_category_id: number
  year: string
  introduction_key?: string
  graduates_in?: number
  phone_number?: string
  application_category_ids: ("1" | "3")[]

  student_experience_type_ids: string[]
  student_achievement_type_ids: string[]
  programming_experience: string
  design_experience: string
  skills?: string[]

  nonce?: string
  redirect_after_auth?: string
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  gad_source?: string

  // application_category_idsに"1"が含まれる時
  job_hunting_status?: string
  major_occupation_ids_for_long_internship?: string[]
  frequency?: number
  frequency_weekday?: number
  available_hours_per_week?: number
  period?: number

  // application_category_idsに"3"が含まれる時
  major_occupation_ids_for_new_grad_jobs?: string[]
  minor_occupation_ids_for_new_grad_jobs?: string[]
  industry_ids?: string[]
  company_type_ids?: string[]

  g_recaptcha_response?: string
}

export const fetchPostAuthRegister = defineFetcher((body: PostAuthRegisterBody): Promise<PostAuthRegister> => {
  return POST("/auth/register", body).catch((e: unknown) => {
    if (e instanceof SyntaxError) {
      //  現在POST:/auth/registerは正常時のレスポンスが空という状態であり、(await fetch()).json()をするとSyntaxErrorが発生する
      // そのため、ここでcatchしてreturn しなければならない
      return {}
    } else {
      // SyntaxErrorではない時はそのエラーを再スローする
      throw e
    }
  })
})

// NOTE: 成功時はそもそもjsonが送られてこない→MockInfraResponseは以下の `return {}` が成功時の値
export type PostAuthRegister = FailedInfraResponse | MockInfraResponse
